import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1y0fkwl2: FaireBrandEntity = {
  token: "b_1y0fkwl2",
  type: "brand",
  name: "Roots And Leaves",
  avatarUrl:
    "https://cdn.faire.com/fastly/8672fd5feb56be36f1d6a868b65ca75b150452cc7554c26185615c11fa1501a1.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/51e280bef7cf6c871169e576b6438af6845b0bf82bae1249a73cbd7a570611e4.png",
  logoUrl:
    "https://cdn.faire.com/fastly/8672fd5feb56be36f1d6a868b65ca75b150452cc7554c26185615c11fa1501a1.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/51e280bef7cf6c871169e576b6438af6845b0bf82bae1249a73cbd7a570611e4.png",
  location: "Aiken, SC, USA",
  minimumOrderDollars: 135,
  rating: 5,
  reviewCount: 326,
  isTopShop: true,
  isInsider: true,
  description:
    "Roots and Leaves was established in 2017 by Haley Maness and was born out of desperation and necessity. I (Haley, Founder/Owner) was diagnosed with Lyme’s disease and mold exposure and it was wreaking havoc on my health and life. Mainstream medical was doing little to help, so I started researching alternative treatments. I was introduced to the healing world of herbs and I haven’t looked back. I quit my job in corporate america and pursued herbalism to heal myself. After I found healing, I became a certified herbalist and began developing every product that you see in my catalog.  Every product that I create is geared towards ultimate health and healing using clean and all natural ingredients. We are a woman and family owned small business focused on quality, organic and sustainable ingredients. We only give to your family what we would give to our own!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:52:24.781Z",
    importedBy: "entity-db-cli",
  },
};
